<template>
  <div>
    <div class="carousel product-gallery">
      <div class="carousel-wrapper">
        <div class="stickers">
          <sticker v-for="(sticker, index) in stickers"
            :key="`stickers ${index}`"
            :sticker="sticker"
          />
        </div>
        <div class="carousel-preview">
          <div class="preview-item-container">
            <div
              :style="{
                width: `${numOfSlides * 100}%`,
                transform: `translateX(${(this.displayedSlide / this.numOfSlides * 100) * -1}%`
              }"
              class="preview-item-wrap"
            >
              <div
                v-for="(item, index) of numOfSlides"
                :key="`preview-item-${index}`"
                class="preview-item"
              >
              <figure>
                <img :src="activeSliderImagesArray[index]" alt="">
              </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex wrap align-center justify-center separator-div">
        <div class="indicator justify-center">
          <div class="indicator-wrap flex">
            <div
              v-for="(slide, index) of numOfSlides"
              :key="`dot-${index}`"
              class="active-slide-indicator"
              :class="{'active' : index === displayedSlide}"
            >
            </div>
          </div>
        </div>
        <div class="carousel-slides-container">
          <div class="carousel-slides-container-wrap" :class="{'single-product' : numOfSlides <= 3}">
            <div
              :style="{
                width: `calc(${(numOfSlides / 3) * 100}%)`,
                transform: `translateX(calc(calc(100% / ${numOfSlides}) * ${currentSlide * -1}))`
              }"
              class="carousel-slides-wrapper"
            >
              <div
                v-for="(slide, index) of numOfSlides"
                class="carousel-slide"
                :style="{width: `calc(100% / ${numOfSlides} - 10px)`}"
                :class="{'active' : index === displayedSlide}"
                :key="`slide-${index}`"
                @click="goToSlide(index)"
                >
                <figure>
                  <img :src="activeSliderImagesArray[index]" alt="">
                </figure>
              </div>
            </div>
          </div>
          <div v-if="numOfSlides > 3">
            <button @click="prevSlide"
                    class="prev navigation-trigger"
                    :class="{'disable': displayedSlide === 0}">
            </button>
            <button @click="nextSlide"
                    class="next navigation-trigger"
                    :class="{'disable': displayedSlide === numOfSlides - 1}">
            </button>
          </div>
        </div>
        <div v-if="sideBoxTrigger" class="side-boxes flex">
          <div class="video-box side-box flex-1 flex column">
            <figure class="flex-1">
              <img src="/assets/images/Rectangle-620.svg" alt="Video">
            </figure>
            <span class="small-font">Video</span>
          </div>
        </div>
      </div>
      <div class="separator-border mb-default"></div>
    </div>
    <div class="flex justify-center hide-md">
      <div class="flex align-center">
        <compare-button :text="$t('compare.compare_devices')"
                        :active="true"
                        @click="compare"
                        class="device-preview-compare-btn"/>
      </div>
    </div>
  </div>
</template>

<script>
import Sticker from '@/components/common/sticker'
import CompareButton from '@/components/compare/compare-button'
import { customEvent } from '@/services/customEventBus'

export default {
  props: {
    device: {
      type: Array
    },
    stickers: {
      type: Array
    }
  },
  components: {
    Sticker, CompareButton
  },
  data () {
    return {
      numOfSlides: 0,
      currentSlide: 0,
      displayedSlide: 0,
      activeSlider: [],
      activeSliderImagesArray: [],
      activeColorCode: null,
      sideBoxTrigger: false // we hide it for now as requested in task MCH-905
    }
  },
  computed: {
    currentColorCode () {
      return this.activeColorCode || this.device[0].code
    }
  },
  created () {
    this.sliderSetup()
  },
  mounted () {
    customEvent.$on('colorPicked', data => {
      this.activeColorCode = data.code
      this.sliderSetup()
    })

    let touchstartX = 0
    let touchendX = 0
    const touchableElement = document.querySelector('.preview-item-container')
    touchableElement.addEventListener('touchstart', event => {
      touchstartX = event.changedTouches[0].screenX
    }, false)
    touchableElement.addEventListener('touchend', event => {
      touchendX = event.changedTouches[0].screenX
      if (touchendX < touchstartX) {
        if (this.displayedSlide < this.numOfSlides - 1) {
          this.displayedSlide++
          this.goToSlide(this.displayedSlide)
        }
      }
      if (touchendX > touchstartX) {
        if (this.displayedSlide > 0) {
          this.displayedSlide--
          this.goToSlide(this.displayedSlide)
        }
      }
    }, false)
  },
  beforeDestroy () {
    customEvent.$off('colorPicked')
  },
  methods: {
    sliderSetup () {
      this.activeSlider = this.device.find(each => each.code === this.currentColorCode).images
      this.activeSliderImagesArray = this.activeSlider.filter(each => each.url).map(i => i.url)
      this.numOfSlides = this.activeSliderImagesArray.length
      // reset sider position
      this.goToSlide(0)
      this.currentSlide = 0
    },
    nextSlide () {
      if (this.displayedSlide >= 2 &&
          this.currentSlide <= this.numOfSlides - 1 &&
          this.numOfSlides > this.displayedSlide + 1) this.currentSlide++
      if (this.displayedSlide !== this.numOfSlides - 1) this.displayedSlide++
    },
    prevSlide () {
      if (this.displayedSlide > 0) this.displayedSlide--
      if (this.displayedSlide > 1 || this.currentSlide >= 1) this.currentSlide--
    },
    goToSlide (param) {
      this.displayedSlide = param
    },
    compare () {
      this.$emit('add-compare')
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel {
  width: 100%;
  padding: 15px;
  padding-bottom: 0;

  @media (#{map-get($breakpoints, sm)}) {
    padding: 15px 30px 0;
  }

  @media (#{map-get($breakpoints, md)}) {
    padding: 70px 15px 0;
  }

  @media (#{map-get($breakpoints, lg)}) {
    padding: 40px 50px 0;
  }

  .separator-div {
    margin: 15px auto;

    @media (#{map-get($breakpoints, lg)}) {
        flex-wrap: nowrap !important;
    }
  }

  .indicator-wrap {
    display: flex;
    justify-content: center;

    .active-slide-indicator {
      background-color: rgba($regular-gray, 0.4);
      max-width: 8px;
      margin: 0 8px;
      &.active {
        min-width: 32px;
        background-color: $regular-gray;
        margin: 0;
      }
    }
  }

  .disable {
    &::after {
      border-color: $form-border-color;
    }
  }
}
.carousel-wrapper {
  width: 100%;
  margin: 0;
  position: relative;
  height: auto;

  @media (#{map-get($breakpoints, sm)}) {
    max-height: 380px;
  }
}
.carousel-preview {
  padding-top: 60%;
  margin: 0 auto;

  @media (#{map-get($breakpoints, sm)}) {
    padding-top: 70%;
  }

  @media (#{map-get($breakpoints, md)}) {
    padding-top: 85%;
  }

  @media (#{map-get($breakpoints, lg)}) {
    padding-top: 67%;
  }
}
.preview-item-container {
  height: calc(100% - 10px);
  width: calc(100% - 10px);
  position: absolute;
  left: 5px;
  top: 5px;
  overflow: hidden;
}
.carousel-slides-container {
  display: none;

  @media (#{map-get($breakpoints, md)}) {
    display: block;
    width: 100%;
    margin: 0 5%;
    height: 60px;
    position: relative;
    margin-bottom: 7px;
  }
}
.side-boxes {
  display: none;

  @media (#{map-get($breakpoints, sm)}) {
    display: flex;
    width: auto;
    margin: 0;
    position: absolute;
    left: 30px;
  }

  @media (#{map-get($breakpoints, md)}) {
    position: relative;
    left: unset;
    margin-top: 25px;
  }

  @media (#{map-get($breakpoints, lg)}) {
    margin: 0 40px;
  }

  .side-box {
    cursor: pointer;
    margin-bottom: 10px;

  @media (#{map-get($breakpoints, md)}) {
      margin-bottom: 0;
    }

    figure {
      height: unset;
      margin-bottom: 10px;
    }
    span {
      display: block;
      text-align: center;
      white-space: nowrap;
    }
    & + .side-box {
      margin-left: 35px;
    }
  }
}
.carousel-slides-container-wrap {
  height: calc(100% + 7px);
  width: 100%;
  position: relative;
  overflow: hidden;
  &.single-product {
    display: flex;
    justify-content: center;
    & > div {
      position: static;
    }
  }
}
.carousel-slides-wrapper,
.preview-item-wrap {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  height: 100%;
  transition: transform 0.5s ease-out;
}
.carousel-slide {
  margin: 0 5px;
  height: calc(100% - 7px);
  position: relative;
  cursor: pointer;
  &.active {
    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -5px;
      width: 100%;
      height: 2px;
      background-color: $primary;
    }
  }
}
.preview-item {
  flex: 1;

}
figure {
  height: 100%;
  width: 100%;
  text-align: center;
  img {
    height: 100%;
    max-height: 380px;
    width: auto;
    max-width: 100%;
  }
}
.separator-border {
  width: 100%;
  height: 1px;
  margin: 25px auto;
  background-color: $grey;
}
.navigation-trigger {
  position: absolute;
  top: 50%;
  height: 20px;
  width: 20px;
  border: none;
  padding: 0;
  &:after {
    position: absolute;
    content: '';
    height: 15px;
    display: block;
    width: 15px;
    top: 50%;
    left: 50%;
    border-bottom: 2px solid $primary;
    border-right: 2px solid $primary;
    transform-origin: center center;
  }
  &.next {
    right: 0;
    transform: translate(100%, -50%);
    &:after {
      transform: translate(-100%, -50%) rotate(-45deg) ;
    }
  }
  &.prev {
    left: 0;
    transform: translate(-100%, -50%);
    &:after {
      transform: translate(0%, -50%) rotate(135deg) ;
    }
  }
}
.stickers {
  position: absolute;
  left: 0;
  top: 145px;
  transform: translateY(-100%);
  display: flex;
  flex-direction: column;
  z-index: 1;

  @media (#{map-get($breakpoints, sm)}) {
    top: 200px;
  }

  @media (#{map-get($breakpoints, md)}) {
    top: 160px;
    left: unset;
    right: 0;
  }
  @media (#{map-get($breakpoints, lg)}) {
    margin-right: 15px;
  }
}
.indicator {
  width: 100%;
  display: flex;

  @media (#{map-get($breakpoints, md)}) {
    display: none;
  }

  .indicator-wrap {
    max-width: 100px;
    width: 100%;
    > div {
      flex: 1;
      transition: 0.3s ease-out;
      height: 4px;
      border-radius: 25px;
      margin: 0 3px;
      background-color: $regular-gray;
    }
    > div.active {
      flex: 2;
      background-color: $black;
    }
  }
}
.compare-device {
  height: 20px;
  width: 20px !important;
  position: relative;
  margin-right: 15px;
  padding: 0;
  &:before,
  &:after {
    content: '';
    height: 70%;
    width: 70%;
    display: block;
    position: absolute;
    background-color: $mtel-red;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &:before {
    height: 1px;
  }
  &:after {
    width: 1px;
  }
  & + span {
    line-height: 1.6;
  }
}
</style>
